import React from "react";

const Terms = () => {
  return (
    <div  style={{
    display: "flex", // Flexbox for alignment
    justifyContent: "center", // Center content horizontally
    alignItems: "center", // Center content vertically
    height: "100vh", // Full viewport height
    backgroundColor: "#f9f9f9", // Optional for aesthetics
    padding: "0", // Ensure no padding on the parent
    margin: "0", // No margin on parent to avoid space
    boxSizing: "border-box", // Ensures padding is included in element's total width/height
    width: "100%", // Ensure the parent takes up full width of the screen
    // Mobile responsiveness
    "@media (max-width: 768px)": {
      padding: "0", // No padding for mobile
      height: "auto", // Allow content to adjust naturally on mobile screens
      width: "100%", // Full width on mobile
    },
  }}
    >
    <iframe
      srcDoc={`
     
<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin:0in;
	line-height:115%;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;}
h3
	{margin-top:16.0pt;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	line-height:115%;
	page-break-after:avoid;
	font-size:14.0pt;
	font-family:"Arial",sans-serif;
	color:#434343;
	font-weight:normal;}
.MsoChpDefault
	{font-family:"Arial",sans-serif;}
.MsoPapDefault
	{line-height:115%;}
@page WordSection1
	{size:8.5in 11.0in;
	margin:1.0in 1.0in 1.0in 1.0in;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>

</head>

<body lang=EN-US style='word-wrap:break-word'>

<div class=WordSection1>

<h3 style='margin-top:14.0pt;page-break-after:auto'><a name="_k8qhibf72kh7"></a><b><span
lang=EN style='font-size:13.0pt;line-height:115%;color:black'>Online Agreement
between Zensark Technologies Pvt Ltd and Healthcare Provider</span></b></h3>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN>1. Agreement Parties</span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>1.1. <b>Zensark Technologies Pvt Ltd</b>
(hereinafter referred to as &quot;Reseller&quot;), a company incorporated under
the laws of India, having its office at F - 204, Beta Block, Jayabheri Silicon
County, Kothaguda, Kondapur, Ranga Reddy, HYDERABAD 500084 Telangana, India is
authorized by Salcit Technologies Private Ltd (Developer) to sell Swaasa<sup>®</sup>,
an SaMD with regulatory approval in India as a Class B medical device.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>1.2. <b>Healthcare Provider / Facilitator</b>
(hereinafter referred to as &quot;User&quot;)</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN>2. Swaasa® AI Platform</span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>2.1. Swaasa® is a cloud-based, non-invasive
device intended to acquire, analyze, and store cough sounds along with
symptoms. It provides an informational report to be reviewed by a licensed
healthcare professional as a screening tool and diagnostic aid in assessing
respiratory conditions.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>2.2. User acknowledges that Swaasa® is
designed for use on adults (18 years and above) in hospitals, physician's
offices, laboratories, medical camps, occupational health environments, and for
self-assessments under healthcare professional guidance.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>2.3. User understands that Swaasa®
provides informational data, not a diagnosis, and should be used as one of
several inputs in making diagnosis and treatment decisions.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN>3. Agreement Terms</span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>3.1. <b>User Rights:</b> User has the
right to provide Swaasa® access to patients for respiratory assessments. User
is responsible for sharing the assessment report with the patient.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>3.2. <b>Commercial:</b> Reseller may
provide incentives from time to time as decided by them. User will encourage
patients to pay directly to Reseller electronically. If User collects fees, the
amounts collected will be remitted to Reseller as per the rules framed by the
Reseller.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>3.3. <b>Data and Privacy:</b> User agrees
to obtain patient consent for each assessment and comply with the Digital
Personal Data Protection (DPDP) Act, 2023.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>3.4. <b>Basic Output:</b> A simple
respiratory risk classification (Low, Medium, High) is provided free of charge.
User shall not charge patients for this basic output.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN>4. General Terms</span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>4.1. <b>Confidentiality:</b> User agrees
to maintain the confidentiality of proprietary information.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>4.2. <b>Term and Termination:</b> This
agreement commences on the date the Swaasa<sup>®</sup> app is downloaded and
continues until such time User deletes their account. Reseller may cancel this
agreement at any time without notice. .</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>4.3. <b>Dispute Resolution:</b> Any
disputes shall be subject to the exclusive jurisdiction of the courts in
Hyderabad, India.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>4.4. <b>Severability:</b> If any
provision is deemed invalid, the remaining provisions shall remain in full
force and effect.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>4.5. <b>Entire Agreement:</b> This
agreement constitutes the entire understanding between the parties.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN>5. Acceptance</span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN>By clicking &quot;I agree,&quot; User
represents and warrants that it has the authority to bind itself to this
agreement and accepts its terms and conditions.<br clear=all style='page-break-before:
always'>
</span></p>

<p class=MsoNormal><span lang=EN>&nbsp;</span></p>

<p class=MsoNormal align=center style='text-align:center'>
  <b><span lang=EN style='font-size:13.0pt;line-height:115%'>Swaasa® AI Platform - User Agreement</span></b>
</p>

<h3 style='margin-top:14.0pt;margin-right:0in;margin-bottom:14.0pt;margin-left:0in;padding-left:0in;text-indent:0in;page-break-after:auto'>
  <a name="_pk9gaow60q6"></a><b><span lang=EN style='font-size:13.0pt;line-height:115%;color:black'>1.<span style='font:7.0pt "Times New Roman"'> </span></span></b><b><span lang=EN style='font-size:13.0pt;line-height:115%;color:black'>Agreement Parties</span></b>
</h3>



<p class=MsoNormal style='margin-left:1.0in;text-indent:-1.0in'><span lang=EN
style='font-size:10.0pt;line-height:115%'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span lang=EN style='font-size:10.0pt;line-height:115%'>Zensark
Technologies Pvt Ltd</span></b><span lang=EN style='font-size:10.0pt;
line-height:115%'>: A company incorporated under the laws of India  with its
office at F - 204, Beta Block, Jayabheri Silicon County, Kothaguda, Kondapur,
Ranga Reddy, Hyderabad 500084 Telangana, India. Zensark Technologies Pvt Ltd is
authorized by Salcit Technologies Private Ltd (Developer) to market and sell
Swaasa®, a regulatory-approved SaMD classified as a Class B medical device in
India.</span></p>

<p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
margin-left:1.0in;text-indent:-1.0in'><span lang=EN style='font-size:10.0pt;
line-height:115%'><span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><b><span lang=EN style='font-size:10.0pt;line-height:115%'>Healthcare
Provider / Facilitator (User):</span></b><span lang=EN style='font-size:10.0pt;
line-height:115%'> The healthcare provider or facilitator using Swaasa® for
respiratory assessments.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN style='font-size:13.0pt;line-height:
115%'>     2. <span style='color:black'>Swaasa® AI Platform</span></span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;margin-bottom:.0001pt;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Platform
Purpose: Swaasa® is a cloud-based, non-invasive device intended to acquire,
analyze, and store cough sounds along with symptoms. It provides an
informational report to be reviewed by a licensed healthcare professional as a
screening tool and diagnostic aid in assessing respiratory conditions.</span></p>

<p class=MsoNormal style='margin-left:1.0in;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Intended
Use: Swaasa® is intended for adults (18+ years) in hospitals, physician's
offices, laboratories, medical camps, occupational health environments, and for
self-assessments under the guidance of a healthcare professional.</span></p>

<p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
margin-left:1.0in;text-indent:-.25in'><span lang=EN style='font-size:10.0pt;
line-height:115%'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Informational
Tool: User acknowledges that Swaasa® provides informational data and is not
intended to serve as a standalone diagnosis tool. Swaasa® should be one of
multiple resources in making diagnostic or treatment decisions<b>.</b></span></p>

<h3 style='margin-top:14.0pt;page-break-after:auto'><a name="_3ecviesmqfs4"></a><b><span
lang=EN style='font-size:13.0pt;line-height:115%;color:black'>    3. Agreement
Terms</span></b></h3>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;margin-bottom:.0001pt;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>User
Rights: User is authorized to offer Swaasa® assessments to patients for
respiratory health evaluations and is responsible for sharing the generated
reports with patients.</span></p>

<p class=MsoNormal style='margin-left:1.0in;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Commercial
Terms:</span></p>

<p class=MsoNormal style='margin-left:94.5pt;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Incentives:
Reseller may provide incentives at its discretion.</span></p>

<p class=MsoNormal style='margin-left:94.5pt;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>●<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Payment:
User will encourage patients to pay Reseller directly via electronic methods.
If User collects payment, they will remit the amount remitted to Reseller.</span></p>

<p class=MsoNormal style='margin-left:1.0in;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Data and
Privacy: User agrees to obtain explicit patient consent for each assessment and
comply with the Digital Personal Data Protection (DPDP) Act, 2023, ensuring
proper data handling practices.</span></p>

<p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
margin-left:1.0in;text-indent:-.25in'><span lang=EN style='font-size:10.0pt;
line-height:115%'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Basic
Output: A complimentary respiratory risk classification (Low, Medium, High)
will be provided to patients. User agrees not to charge patients for this basic
output.</span></p>

<h3 style='margin-top:14.0pt;page-break-after:auto'><a name="_p07ra3h26v31"></a><b><span
lang=EN style='font-size:13.0pt;line-height:115%;color:black'>    4. General
Terms</span></b></h3>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;margin-bottom:.0001pt;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Confidentiality:
User agrees to maintain confidentiality and protect proprietary information
exchanged under this Agreement.</span></p>

<p class=MsoNormal style='margin-left:1.0in;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Term and
Termination: This Agreement begins when User downloads the Swaasa® app and
remains in effect until User deletes their account. Reseller reserves the right
to terminate this Agreement at any time without prior notice.</span></p>

<p class=MsoNormal style='margin-left:1.0in;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Dispute
Resolution: Any disputes arising under this Agreement will be subject to the
exclusive jurisdiction of the courts in Hyderabad, India.</span></p>

<p class=MsoNormal style='margin-left:1.0in;text-indent:-.25in'><span lang=EN
style='font-size:10.0pt;line-height:115%'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Severability:
If any provision of this Agreement is found to be invalid, the remaining
provisions shall continue in full force and effect.</span></p>

<p class=MsoNormal style='margin-top:0in;margin-right:0in;margin-bottom:12.0pt;
margin-left:1.0in;text-indent:-.25in'><span lang=EN style='font-size:10.0pt;
line-height:115%'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN style='font-size:10.0pt;line-height:115%'>Entire
Agreement: This Agreement constitutes the complete understanding between the
parties and supersedes all prior communications, agreements, or understandings.</span></p>

<h3 style='margin-top:14.0pt;page-break-after:auto'><a name="_ylte225wc7yw"></a><b><span
lang=EN style='font-size:13.0pt;line-height:115%;color:black'>    5. Acceptance</span></b></h3>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:31.5pt'><span lang=EN style='font-size:10.0pt;line-height:
115%'>By clicking &quot;I agree,&quot; User confirms having the authority to
bind themselves to this Agreement and hereby accepts all terms and conditions
outlined above.</span></p>

<p class=MsoNormal style='margin-left:.5in'><b><span lang=EN style='font-size:
10.0pt;line-height:115%'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-left:.5in'><b><span lang=EN style='font-size:
10.0pt;line-height:115%'>[  ]  I Agree</span></b></p>

<p class=MsoNormal align=center style='margin-left:.5in;text-align:center'><b><span
lang=EN style='font-size:13.0pt;line-height:115%'>&nbsp;</span></b></p>

<span lang=EN style='font-size:11.0pt;line-height:115%;font-family:"Arial",sans-serif'><br
clear=all style='page-break-before:always'>
</span>

<p class=MsoNormal align=center style='margin-left:.5in;text-align:center'><b><span
lang=EN style='font-size:13.0pt;line-height:115%'>&nbsp;</span></b></p>

<p class=MsoNormal align=center style='margin-left:.5in;text-align:center'><b><span
lang=EN style='font-size:13.0pt;line-height:115%'>Swaasa® Patient Consent
Agreement</span></b></p>

<p class=MsoNormal style='margin-left:.5in'><b><span lang=EN style='font-size:
10.0pt;line-height:115%'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN style='font-size:10.0pt;line-height:115%'>This
is an agreement between Zensark Technologies Pvt Ltd (&quot;Zensark&quot;) and
the individual patient (&quot;Patient&quot;). By clicking &quot;I Agree,&quot;
the Patient consents to the collection, use, and processing of personal health
data. Zensark, located at F - 204, Beta Block, Jayabheri Silicon County,
Kothaguda, Kondapur, Ranga Reddy, Hyderabad 500084 Telangana, India, provides
access to Swaasa®, a cloud-based, non-invasive device designed to acquire and
analyze cough sounds and related health data.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN style='font-size:10.0pt;line-height:115%'>By
using Swaasa®, the Patient agrees to the collection of cough recordings,
symptom details, and demographic information for generating a respiratory
assessment report. This report is informational and not a medical diagnosis.
Patients must consult licensed healthcare professionals for diagnosis or
treatment decisions.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN style='font-size:10.0pt;line-height:115%'>The
Patient's data may be anonymized for research and platform improvement.
Identifiable data will not be shared with third parties without explicit
consent, except where required by law. The Patient has the right to withdraw
consent, request access to, or delete their data by contacting Zensark or
deleting their account. Zensark ensures compliance with the Digital Personal
Data Protection (DPDP) Act, 2023, to safeguard Patient data.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN style='font-size:10.0pt;line-height:115%'>This
agreement begins when the Patient clicks &quot;I Agree&quot; and remains valid
until consent is withdrawn or the account is deleted. Any disputes will be
resolved under the jurisdiction of the courts in Hyderabad, India.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><span lang=EN style='font-size:10.0pt;line-height:115%'>By
clicking &quot;I Agree,&quot; the Patient confirms they are at least 18 years
old, legally capable of consenting, and accept the terms outlined above.</span></p>

<p class=MsoNormal style='margin-top:12.0pt;margin-right:0in;margin-bottom:
12.0pt;margin-left:0in'><b><span lang=EN style='font-size:10.0pt;line-height:
115%'>[ ]  I Agree</span></b></p>

<p class=MsoNormal style='margin-left:.5in'><b><span lang=EN style='font-size:
10.0pt;line-height:115%'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-left:.5in'><b><span lang=EN style='font-size:
10.0pt;line-height:115%'>&nbsp;</span></b></p>

</div>

</body>

</html>

      `}
      style={{
        width: "100%", // Full width for iframe on mobile and desktop
        height: "90vh", // Adjust height to be a percentage of the viewport height
        border: "none", // Remove default iframe border
        margin: "0", // Remove margins to avoid extra space
        display: "block", // Make iframe a block element to center it
        backgroundColor: "#fff", // Optional, for consistency with the document look
        boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)", // Optional shadow for lift effect
        borderRadius: "8px", // Slight rounding of corners for a modern look
        padding: "0", // Remove padding
        overflowY: "auto", // Ensure scrolling if content exceeds iframe size
        boxSizing: "border-box", // Ensure padding and borders are accounted for
        // Mobile responsiveness (less emphasis on margins and centering)
        "@media (max-width: 768px)": {
          height: "80vh", // Adjust height for mobile view
          margin: "0", // Remove margin for mobile devices
          padding: "0", // Remove padding on mobile devices
          boxShadow: "none", // Optional: remove shadow for mobile
        },
      }}
      
    />
    </div>
  );
};

export default Terms;
